module.exports = __webpack_public_path__ + "img/Rectangle.8aedf9fe.png";